import React, { useState, useCallback } from 'react';
import BarChart from 'charts/BarChart01';
import Datepicker from 'components/actions/DatePicker';
import { ExportCSV } from 'components/ExportCSV';
import LayoutWrapper from 'components/LayoutWrapper';
import AnalyticsSerive from 'api/services/AnalyticsService';
import { getDateRangeString, tailwindConfig, getI18nValue } from 'utils/Utils';
import { useTranslation } from "react-i18next";
import { useAxios } from 'hooks/useAxios';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';

const MessagesPerDay = () => {
    const { t } = useTranslation();

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );

    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(AnalyticsSerive.getMessagesPerDay(selectedDateRanges, channel, language))


    return (

        <div className='p-4 col-span-full sm:col-span-full xl:col-span-full bg-white shadow-sm rounded-sm border border-gray-200 min-h-[480px] flex flex-col'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-gray-100 mb-4">
                <div className='mb-4'>
                    <header className='capitalize text-xl font-semibold text-gray-800 '>{t(getI18nValue('analytics.messages_per_day', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.messages_per_day', "description"))}</p>
                </div>

                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`messages_${getDateRangeString(selectedDateRanges)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <LanguageSelect value={language} onChange={setLanguage} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>

            <LayoutWrapper error={error} loading={loading} variant="chart" isEmpty={!loading && !data} className="flex-1 min-h-0">
                {!!data && <BarChart data={{
                    labels: data?.date ? data?.date : [],
                    datasets: [
                        // Handled Requests bars
                        {
                            label: t(getI18nValue('analytics.messages_per_day', "handled_messages")),
                            data: data?.handled_messages ? data?.handled_messages : [],
                            backgroundColor: tailwindConfig().theme.colors.blue[400],
                            hoverBackgroundColor: tailwindConfig().theme.colors.blue[500],
                            barPercentage: 0.66,
                            categoryPercentage: 0.66,
                        },
                        // Unhandled Requests bars
                        {
                            label: t(getI18nValue('analytics.messages_per_day', "unhandled_messages")),
                            data: data?.unhandled_messages ? data?.unhandled_messages : [],
                            backgroundColor: tailwindConfig().theme.colors.red[500],
                            hoverBackgroundColor: tailwindConfig().theme.colors.red[600],
                            barPercentage: 0.66,
                            categoryPercentage: 0.66,
                        },
                    ],
                }} />}


            </LayoutWrapper>

        </div >

    );
}

export default MessagesPerDay;